export default [
  {
    OPT_CLAS_CD: 'OPT00001',
    OPT_CLAS_NM: '푸드',
    OPT_CLAS_KO_NM: '푸드',
    OPT_CLAS_JP_NM: 'フード',
    OPT_CLAS_EN_NM: 'Food',
    OPT_CLAS_CN_NM: '',
    OPT_CLAS_TW_NM: '',
    OPT_CLAS_TYPE: '',
    OPT_ORDER: 1,
    OPT_MULTI_USE_YN: 'N',
    OPT_URPC: 0,
    IMG_YN: 'N',
    OPT_GRP_CD: '001',
    OPT_GBN: '03',
  },
  {
    OPT_CLAS_CD: 'OPT00002',
    OPT_CLAS_NM: '사이즈선택',
    OPT_CLAS_KO_NM: '사이즈선택',
    OPT_CLAS_JP_NM: 'サイズ',
    OPT_CLAS_EN_NM: ' Size',
    OPT_CLAS_CN_NM: '',
    OPT_CLAS_TW_NM: '',
    OPT_CLAS_TYPE: '',
    OPT_ORDER: 2,
    OPT_MULTI_USE_YN: 'N',
    OPT_URPC: 0,
    IMG_YN: 'N',
    OPT_GRP_CD: '001',
    OPT_GBN: '01',
  },
  {
    OPT_CLAS_CD: 'OPT00002',
    OPT_CLAS_NM: '사이즈선택',
    OPT_CLAS_KO_NM: '사이즈선택',
    OPT_CLAS_JP_NM: 'サイズ',
    OPT_CLAS_EN_NM: ' Size',
    OPT_CLAS_CN_NM: '',
    OPT_CLAS_TW_NM: '',
    OPT_CLAS_TYPE: '',
    OPT_ORDER: 2,
    OPT_MULTI_USE_YN: 'N',
    OPT_URPC: 0,
    IMG_YN: 'N',
    OPT_GRP_CD: '002',
    OPT_GBN: '01',
  },
  {
    OPT_CLAS_CD: 'SOP00004',
    OPT_CLAS_NM: '원두종류',
    OPT_CLAS_KO_NM: '원두종류',
    OPT_CLAS_JP_NM: 'Type',
    OPT_CLAS_EN_NM: 'Type',
    OPT_CLAS_CN_NM: '',
    OPT_CLAS_TW_NM: '',
    OPT_CLAS_TYPE: '',
    OPT_ORDER: 4,
    OPT_MULTI_USE_YN: 'Y',
    OPT_URPC: 0,
    IMG_YN: 'N',
    OPT_GRP_CD: 'S003',
    OPT_GBN: '01',
  },
  {
    OPT_CLAS_CD: 'SOP00005',
    OPT_CLAS_NM: '원두종류2',
    OPT_CLAS_KO_NM: '원두종류2',
    OPT_CLAS_JP_NM: 'Type2',
    OPT_CLAS_EN_NM: 'Type2',
    OPT_CLAS_CN_NM: '',
    OPT_CLAS_TW_NM: '',
    OPT_CLAS_TYPE: '',
    OPT_ORDER: 5,
    OPT_MULTI_USE_YN: 'N',
    OPT_URPC: 0,
    IMG_YN: 'N',
    OPT_GRP_CD: 'S003',
    OPT_GBN: '01',
  },
  {
    OPT_CLAS_CD: 'SOP00005',
    OPT_CLAS_NM: '원두종류2',
    OPT_CLAS_KO_NM: '원두종류2',
    OPT_CLAS_JP_NM: 'Type2',
    OPT_CLAS_EN_NM: 'Type2',
    OPT_CLAS_CN_NM: '',
    OPT_CLAS_TW_NM: '',
    OPT_CLAS_TYPE: '',
    OPT_ORDER: 5,
    OPT_MULTI_USE_YN: 'N',
    OPT_URPC: 0,
    IMG_YN: 'N',
    OPT_GRP_CD: 'S004',
    OPT_GBN: '01',
  },
  {
    OPT_CLAS_CD: 'SOP00006',
    OPT_CLAS_NM: '컵',
    OPT_CLAS_KO_NM: '컵',
    OPT_CLAS_JP_NM: 'Cup',
    OPT_CLAS_EN_NM: 'Cup',
    OPT_CLAS_CN_NM: '',
    OPT_CLAS_TW_NM: '',
    OPT_CLAS_TYPE: '',
    OPT_ORDER: 6,
    OPT_MULTI_USE_YN: 'N',
    OPT_URPC: 0,
    IMG_YN: 'Y',
    OPT_GRP_CD: 'S003',
    OPT_GBN: '01',
  },
  {
    OPT_CLAS_CD: 'SOP00007',
    OPT_CLAS_NM: '퍼스널옵션',
    OPT_CLAS_KO_NM: '퍼스널옵션',
    OPT_CLAS_JP_NM: 'Personal Option',
    OPT_CLAS_EN_NM: 'Personal Option',
    OPT_CLAS_CN_NM: '',
    OPT_CLAS_TW_NM: '',
    OPT_CLAS_TYPE: '',
    OPT_ORDER: 7,
    OPT_MULTI_USE_YN: 'N',
    OPT_URPC: 0,
    IMG_YN: 'Y',
    OPT_GRP_CD: 'S003',
    OPT_GBN: '01',
  },
  {
    OPT_CLAS_CD: 'SOP00007',
    OPT_CLAS_NM: '퍼스널옵션',
    OPT_CLAS_KO_NM: '퍼스널옵션',
    OPT_CLAS_JP_NM: 'Personal Option',
    OPT_CLAS_EN_NM: 'Personal Option',
    OPT_CLAS_CN_NM: '',
    OPT_CLAS_TW_NM: '',
    OPT_CLAS_TYPE: '',
    OPT_ORDER: 7,
    OPT_MULTI_USE_YN: 'N',
    OPT_URPC: 0,
    IMG_YN: 'Y',
    OPT_GRP_CD: 'S004',
    OPT_GBN: '01',
  },
];
